import { useMemo } from "react";

import type { BlOption } from "Shared/Inputs/BlOption";
import { useModulesQuery } from "./useModulesQuery";

export function useModuleOptions(): BlOption[] {
  const { data } = useModulesQuery({ limit: 1000 });

  return useMemo(
    () =>
      (data?.items ?? []).map((module) => ({
        value: module.moduleID.toString(),
        label: module.name,
      })),
    [data],
  );
}
